import React from 'react'
import { useNavigate } from 'react-router-dom'
import AppActionMenu from '../../../../components/AppActionMenu'

export default function EventsTable({
  records = [],
  loading = false,
  onDelete,
}) {
  const navigate = useNavigate()

  const formatDate = (dStr) => {
    if (!dStr) return '—'
    try {
      return new Date(dStr).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
    } catch {
      return dStr
    }
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[960px] text-left text-xs text-on-surface">
          {/* ── Table Header ── */}
          <thead className="border-b border-outline-variant/25 bg-surface-container-low/80 text-[11px] font-black uppercase tracking-[0.1em] text-on-surface-variant select-none">
            <tr>
              <th className="w-36 px-4 py-3.5">
                <span>Date</span>
              </th>
              <th className="px-4 py-3.5">
                <span>Event</span>
              </th>
              <th className="w-44 px-4 py-3.5">
                <span>Institute</span>
              </th>
              <th className="w-36 px-4 py-3.5">
                <span>Branch</span>
              </th>
              <th className="w-40 px-4 py-3.5">
                <span>Course</span>
              </th>
              <th className="w-44 px-4 py-3.5">
                <span>Batch</span>
              </th>
              <th className="w-16 px-4 py-3.5 text-right">
                <span>Action</span>
              </th>
            </tr>
          </thead>

          {/* ── Table Body ── */}
          <tbody className="divide-y divide-outline-variant/15 font-medium">
            {loading ? (
              <tr>
                <td colSpan={7} className="py-16 text-center text-xs text-on-surface-variant">
                  <div className="flex flex-col items-center justify-center gap-2">
                    <span className="material-symbols-outlined animate-spin text-2xl text-primary">
                      progress_activity
                    </span>
                    <span>Loading events list...</span>
                  </div>
                </td>
              </tr>
            ) : records.length === 0 ? (
              <tr>
                <td colSpan={7} className="py-16 text-center text-xs text-on-surface-variant">
                  <div className="flex flex-col items-center justify-center gap-2">
                    <span className="material-symbols-outlined text-4xl text-outline-variant">
                      event_busy
                    </span>
                    <p className="font-bold text-on-surface">No Events Found</p>
                    <p className="text-[11px]">Click &quot;Add New&quot; to schedule your first event.</p>
                  </div>
                </td>
              </tr>
            ) : (
              records.map((item) => (
                <tr
                  key={item.id}
                  className="group transition-colors hover:bg-surface-container-low/50"
                >
                  {/* Date */}
                  <td className="px-4 py-3.5 align-top">
                    <span className="text-xs font-bold text-on-surface flex items-center gap-1.5">
                      <span className="material-symbols-outlined text-sm text-primary">
                        calendar_today
                      </span>
                      <span>{formatDate(item.tDate)}</span>
                    </span>
                  </td>

                  {/* Event Title */}
                  <td className="px-4 py-3.5 align-top">
                    <div className="flex flex-col gap-0.5">
                      <button
                        type="button"
                        onClick={() => navigate(`/cloud/events/edit/${item.id}`)}
                        className="font-display text-sm font-extrabold text-[#3b82f6] hover:underline text-left cursor-pointer"
                      >
                        {item.title}
                      </button>
                      {item.particulars && (
                        <p className="text-[11px] text-on-surface-variant line-clamp-1">
                          {item.particulars}
                        </p>
                      )}
                    </div>
                  </td>

                  {/* Institute */}
                  <td className="px-4 py-3.5 align-top text-on-surface text-xs font-semibold">
                    {item.instituteName}
                  </td>

                  {/* Branch */}
                  <td className="px-4 py-3.5 align-top text-on-surface-variant text-xs">
                    {item.branchName}
                  </td>

                  {/* Course */}
                  <td className="px-4 py-3.5 align-top">
                    <span className="inline-flex items-center rounded-lg bg-primary/10 px-2 py-0.5 text-[11px] font-bold text-primary">
                      {item.courseName}
                    </span>
                  </td>

                  {/* Batch */}
                  <td className="px-4 py-3.5 align-top text-on-surface-variant text-xs">
                    {item.batchName}
                  </td>

                  {/* Actions (Three-Dot AppActionMenu) */}
                  <td className="px-4 py-3.5 align-top text-right">
                    <AppActionMenu
                      triggerLabel=""
                      triggerIcon="more_vert"
                      showChevron={false}
                      triggerClassName="rounded-lg p-1.5 text-outline-variant transition-colors hover:bg-surface-container-low hover:text-primary bg-transparent cursor-pointer"
                      items={[
                        { key: 'edit', label: 'Edit', icon: 'edit' },
                        { key: 'delete', label: 'Delete', icon: 'delete', destructive: true },
                      ]}
                      onSelect={(actionKey) => {
                        if (actionKey === 'edit') navigate(`/cloud/events/edit/${item.id}`)
                        if (actionKey === 'delete') onDelete?.(item.id)
                      }}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
